import { push } from 'connected-react-router';
import { put } from 'redux-saga/effects';
import type { RequestResult } from '@ackee/antonio-core';
import { generatePath } from 'react-router';

import * as Log from 'config/loglevel';
import config from 'config';
import { authApi } from 'config/antonio';
import { actions as formActions, takeFormSubmission } from 'modules/form';
import { createUIErrorMessage } from 'modules/errors';

import type { ForgottenPasswordEmailValues } from '../../types';
import { forms } from '../../config';
import { ForgotPasswordSteps } from '../../types';
import { FORGOTTEN_PASSWORD_EMAIL_STORAGE_KEY } from '../../constants';

interface ForgotPasswordResponse {
    message: string;
    isForceChangePassword: boolean;
}

function* handleForgottenPasswordEmailForm(action: formActions.types.SubmitFormAction<ForgottenPasswordEmailValues>) {
    const { email } = action.payload;

    try {
        const response: RequestResult<ForgotPasswordResponse> = yield* authApi.post(config.api.forgotPassword, {
            username: email,
        });
        const { isForceChangePassword } = response.data;

        yield put(formActions.submitFormSuccess(forms.forgottenPasswordEmail));

        if (isForceChangePassword) {
            localStorage.removeItem(FORGOTTEN_PASSWORD_EMAIL_STORAGE_KEY);
            yield put(push({ pathname: config.routes.login, state: { forceChangePassword: true } }));
            return;
        }

        localStorage.setItem(FORGOTTEN_PASSWORD_EMAIL_STORAGE_KEY, email);
        yield put(push(generatePath(config.routes.forgotPassword, { step: ForgotPasswordSteps.PASSWORD })));
    } catch (error) {
        Log.error(error);

        const uiError = createUIErrorMessage(error);
        yield put(formActions.submitFormFailure(forms.forgottenPasswordEmail, uiError));
    }
}

export default function* forgottenPasswordEmail() {
    yield takeFormSubmission(forms.forgottenPasswordEmail, handleForgottenPasswordEmailForm);
}
